/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    Badge,
    Button,
    Heading,
    TextBlock,
    Text,
    useBreakpoint,
    useFlags,
} from 'sarsaparilla';
import { useWizardContext } from 'ui-interagency-pass/src/components/PassWizard/context/WizardContext';

import './Hero.scss';

function Hero() {
    const { isLgAndUp } = useBreakpoint();
    const { releaseDigitalIapFeatures } = useFlags();
    const wizardEnabled = releaseDigitalIapFeatures?.helpMeChooseWizard ?? false;
    const { openWizard } = useWizardContext();

    const backgroundImage = `${process.env['CDN']}/img/pass/hero/pass-hero-md.webp`;

    return (
        <section aria-label="Buy a Pass" className="pass-hero-section">
            <div className="hero-body-outer-wrap">
                <div className="hero-body">
                    <Heading
                        headingAlign="center"
                        headingLevel={1}
                        hasUnderline="center"
                        underlineColor="brand-02"
                        className="hero-heading"
                        appearance="h1"
                    >
                        Buy a Pass
                    </Heading>
                    {isLgAndUp && (
                        <TextBlock>
                            <Text className="hero-subheading" size="lg">
                                Enjoy the convenience of purchasing a pass before your
                                visit to cover entrance or standard amenity (day use)
                                fees. Check out your options below to find the right pass
                                for you!
                            </Text>
                        </TextBlock>
                    )}
                    <div className="hero-link-group">
                        <a
                            href="#digital-interagency-passes"
                            data-ga-tracking-id="056161084724"
                        >
                            <Badge className="new-badge">NEW</Badge>
                            Get a Digital America the Beautiful Pass to visit multiple
                            locations
                        </a>
                        <a
                            href="#site-specific-digital-passes"
                            data-ga-tracking-id="056161084724"
                        >
                            Buy a Digital Site Pass to visit a single location
                        </a>
                    </div>
                    {wizardEnabled ? (
                        <Button
                            appearance="solid-white"
                            onClick={openWizard}
                            gaTrackingId="056161084724"
                            className="wizard-button"
                        >
                            Help Me Choose a Pass
                        </Button>
                    ) : (
                        <Button
                            appearance="link"
                            href="#which-pass"
                            gaTrackingId="056161084724"
                        >
                            Which Pass Do I Need?
                        </Button>
                    )}
                </div>
                <div className="hero-background-image-overlay" />
                <img
                    alt="Body of water surrounded by hills of trees"
                    src={backgroundImage}
                    className="hero-background-image"
                />
            </div>
        </section>
    );
}

export default Hero;
